import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { getStatusText } from '../../../../shipping/fulfillments/columns/status';

const useFulfillmentService = (fulfillmentServiceId) => {
  return useSelector((state) => {
    const fulfillmentServices = Global.selectSellerFulfillmentServices(state) || [];
    const service = fulfillmentServices.find((fs) => fs.fulfillmentServiceId === fulfillmentServiceId);
    return service?.name;
  });
};

export const useExternalFulfillmentDisplay = ({
  carrierName,
  delegationDate,
  errorMessage,
  externalFulfillmentStatus,
  fulfillmentProviderName,
  isVoided,
  isVoidRequested,
  rate,
  fulfillmentServiceId,
  shipDate,
  trackingNumber,
  trackingStatus,
  trackingUrl,
}) => {
  const statusMessageDescriptor = getStatusText({
    errorMessage,
    externalFulfillmentStatus,
    isVoided,
    isVoidRequested,
    trackingStatus,
  });
  const service = useFulfillmentService(fulfillmentServiceId);

  return useMemo(
    () => ({
      carrierName,
      delegationDate,
      fulfillmentProviderName,
      rate,
      service,
      shipDate,
      statusMessageDescriptor,
      trackingNumber,
      trackingUrl,
    }),
    [carrierName, delegationDate, fulfillmentProviderName, rate, service, shipDate, statusMessageDescriptor, trackingNumber, trackingUrl],
  );
};
